<template>
  <div>
      <div id="app">
        <head>
          <title> Benjamin Mättö - Portfolio</title>
          <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png">
          <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png">
          <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png">
          <link rel="manifest" href="/site.webmanifest">
          <meta name="msapplication-TileColor" content="#da532c">
          <meta name="theme-color" content="#ffffff">

          <meta property="og:title" content="Benjamin Mättö - Portfolio"/>
          <meta property="og:image" content="/Networkthumb.png"/>

        </head>
        <NavbarMobile v-if="showNav"/>
        <div class= "content" :class="{'open':showNav}">
          <div class="top-bar">
            <div class="openbtn" id="openButton" v-if="mobileView.mobileViewR"
              @click="showNav = !showNav">
              &#9776;
            </div>
            </div>
          <div id="navigation-icon" >
          </div>
        <Navbar v-if="!mobileView.mobileViewR"/>
          <div class="routerview">
            <router-view/>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
//import Sidebar from '@/components/Sidebar.vue'
import Navbar from '@/components/Navbar.vue'
import NavbarMobile from '@/components/Navbar-mobile.vue'
import {ref, reactive} from 'vue'

export default{
  name: "App",
  components:{
    //Sidebar,
    Navbar,
    NavbarMobile
  },
  data: () => {
    return{
    }
  },
  methods: {
  },
  setup(){
      let mobileView = reactive({mobileViewR: window.innerWidth <= 990});
      const showNav = ref();
      console.log(mobileView.value);

      window.addEventListener('resize', () => {mobileView.mobileViewR = window.innerWidth <= 990;});
      

      return {
        mobileView,
        showNav
      }
  },
  mounted(){
    document.title = "Benjamin Mättö - Portfolio"
  }
}
</script>
<style>

@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;600&display=swap);

body, html{
  background-color: #282828;
  font-family: 'Source Sans Pro', sans-serif;
}

@media screen and (min-width: 601px) {
  p{
    font-size: 24px;
  }
  h1{
    font-size: 72px;
  }
}
@media screen and (max-width: 600px) {
  p{
    font-size: 18px;
  }
  h1{
    font-size: 50px;
  }
}

li{
  font-size: 24px;
}

#app {
  font-family: 'Source Sans Pro', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #eddbb2;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

h1{
    text-align: center;
    color: #eddbb2;
}
h2{
  font-size: 2vw;
  color: #eddbb2;
}
.content
{
  position: absolute;
  top: 10px;
  width: calc(100% - 30px);
  height: calc(100% - 30px);
}

.open{
  transform: translateX(300px);
}
.openbtn{
    font-family: 'Source Sans Pro';
    font-size: 48px;
    cursor: pointer;
    padding: 10px 15px;
    border: none;
    transition: 0.5s;
    margin-right: 10px;
    text-align: left;
    width: 48px;
}
a:link{
  color: #eddbb2;
}
a:visited{
  color: #eddbb2;
}
a:hover{
  color: #eddbb2;
  opacity: 0.5;
  transition: opacity 0.6s;
}


</style>
